import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Text} from '@edume/magnificent';

import styles from './styles.module.scss';

const QuestionPreviewButton = ({containerRef, contentRef, text}) => (
  <button
    ref={containerRef}
    styleName='button'
    data-automation='button-text-preview'
  >
    <Text size='s' maxLines={2} colour='white' lineHeight='tight'>
      <span ref={contentRef}>{text}</span>
    </Text>
  </button>
);

QuestionPreviewButton.propTypes = {
  containerRef: PropTypes.object,
  contentRef: PropTypes.object,
  text: PropTypes.string.isRequired,
};

export default CSSModules(QuestionPreviewButton, styles);
